import gql from "graphql-tag";
import GraphQLClient, { RequestParam } from "../api";
import {
  ProperNoun,
  ProperNounCustomCategory,
  CreateProperNoun,
  UpdateProperNoun,
  DeleteProperNoun,
  CreateProperNounCustomCategory,
  UpdateProperNounCustomCategory,
  DeleteProperNounCustomCategory,
} from "../models";

interface IProperNounClient {
  fetchAllProperNouns(novelId: string): Promise<ProperNoun[]>;
  createProperNoun(payload: CreateProperNoun): Promise<ProperNoun>;
  updateProperNoun(payload: UpdateProperNoun): Promise<ProperNoun>;
  deleteProperNoun(payload: DeleteProperNoun): Promise<ProperNoun>;
  fetchAllCustomCategories(novelId: string): Promise<ProperNounCustomCategory[]>;
  createCustomCategory(payload: CreateProperNounCustomCategory): Promise<ProperNounCustomCategory>;
  updateCustomCategory(payload: UpdateProperNounCustomCategory): Promise<ProperNounCustomCategory>;
  deleteCustomCategory(payload: DeleteProperNounCustomCategory): Promise<ProperNounCustomCategory>;
}

export class ProperNounClient implements IProperNounClient {
  async fetchAllProperNouns(novelId: string): Promise<ProperNoun[]> {
    const params: RequestParam = {
      query: listProperNounQuery,
      variables: { input: { novelId } },
    };
    const { listProperNoun } = await GraphQLClient.request(params);
    return listProperNoun;
  }

  async createProperNoun(payload: CreateProperNoun): Promise<ProperNoun> {
    const params: RequestParam = {
      query: createProperNounMutation,
      variables: { input: { ...payload } },
    };
    const { createProperNoun } = await GraphQLClient.request(params);
    return createProperNoun;
  }

  async updateProperNoun(payload: UpdateProperNoun): Promise<ProperNoun> {
    const params: RequestParam = {
      query: updateProperNounMutation,
      variables: { input: { ...payload } },
    };
    const { updateProperNoun } = await GraphQLClient.request(params);
    return updateProperNoun;
  }

  async deleteProperNoun(payload: DeleteProperNoun): Promise<ProperNoun> {
    const params: RequestParam = {
      query: deleteProperNounMutation,
      variables: { input: { ...payload } },
    };
    const { deleteProperNoun } = await GraphQLClient.request(params);
    return deleteProperNoun;
  }

  async fetchAllCustomCategories(novelId: string): Promise<ProperNounCustomCategory[]> {
    const params: RequestParam = {
      query: listProperNounCustomCategoryQuery,
      variables: { input: { novelId } },
    };
    const { listProperNounCustomCategory } = await GraphQLClient.request(params);
    return listProperNounCustomCategory;
  }

  async createCustomCategory(payload: CreateProperNounCustomCategory): Promise<ProperNounCustomCategory> {
    const params: RequestParam = {
      query: createProperNounCustomCategoryMutation,
      variables: { input: { ...payload } },
    };
    const { createProperNounCustomCategory } = await GraphQLClient.request(params);
    return createProperNounCustomCategory;
  }

  async updateCustomCategory(payload: UpdateProperNounCustomCategory): Promise<ProperNounCustomCategory> {
    const params: RequestParam = {
      query: updateProperNounCustomCategoryMutation,
      variables: { input: { ...payload } },
    };
    const { updateProperNounCustomCategory } = await GraphQLClient.request(params);
    return updateProperNounCustomCategory;
  }

  async deleteCustomCategory(payload: DeleteProperNounCustomCategory): Promise<ProperNounCustomCategory> {
    const params: RequestParam = {
      query: deleteProperNounCustomCategoryMutation,
      variables: { input: { ...payload } },
    };
    const { deleteProperNounCustomCategory } = await GraphQLClient.request(params);
    return deleteProperNounCustomCategory;
  }
}

/**
 * Field selections
 */

const properNounFields = `
  novelId
  properNounId
  name
  properNounCategory
  materialAttribute
  materialId
  createdAt
  updatedAt
`;

const customCategoryFields = `
  novelId
  properNounCustomCategoryId
  name
  createdAt
  updatedAt
`;

/**
 * ProperNoun Queries / Mutations
 */

const listProperNounQuery = gql`
  query ListProperNoun($input: ListProperNounInput!) {
    listProperNoun(input: $input) {
      ${properNounFields}
    }
  }
`;

const createProperNounMutation = gql`
  mutation CreateProperNoun($input: CreateProperNounInput!) {
    createProperNoun(input: $input) {
      ${properNounFields}
    }
  }
`;

const updateProperNounMutation = gql`
  mutation UpdateProperNoun($input: UpdateProperNounInput!) {
    updateProperNoun(input: $input) {
      ${properNounFields}
    }
  }
`;

const deleteProperNounMutation = gql`
  mutation DeleteProperNoun($input: DeleteProperNounInput!) {
    deleteProperNoun(input: $input) {
      ${properNounFields}
    }
  }
`;

/**
 * ProperNounCustomCategory Queries / Mutations
 */

const listProperNounCustomCategoryQuery = gql`
  query ListProperNounCustomCategory($input: ListProperNounCustomCategoryInput!) {
    listProperNounCustomCategory(input: $input) {
      ${customCategoryFields}
    }
  }
`;

const createProperNounCustomCategoryMutation = gql`
  mutation CreateProperNounCustomCategory($input: CreateProperNounCustomCategoryInput!) {
    createProperNounCustomCategory(input: $input) {
      ${customCategoryFields}
    }
  }
`;

const updateProperNounCustomCategoryMutation = gql`
  mutation UpdateProperNounCustomCategory($input: UpdateProperNounCustomCategoryInput!) {
    updateProperNounCustomCategory(input: $input) {
      ${customCategoryFields}
    }
  }
`;

const deleteProperNounCustomCategoryMutation = gql`
  mutation DeleteProperNounCustomCategory($input: DeleteProperNounCustomCategoryInput!) {
    deleteProperNounCustomCategory(input: $input) {
      ${customCategoryFields}
    }
  }
`;
